/** World events → effects: Moving about: dashes, qinggong jumps, landings, mounting the sword, the weapon put away or drawn. Moved verbatim from Effects.handle (render/effects.ts). */

import { registerFxEvent } from './registry';

const R = Math.random;

registerFxEvent('dash', (host, _ev, w) => {
  const p = w.player;
  const [x, y] = host.pos(p);
  host.dust(x, y, 8, 4, 50);
  host.fx.push({ type: 'ring', x, y, t: 0, life: 0.3, r: 16, col: '200,235,255' });
  host.sfx.dash();
});

registerFxEvent('jump', (host, ev, w) => {
  // Qinggong: dust on take-off; the second jump kicks off a ring of qi in mid-air and somersaults.
  const p = w.player;
  const [x, y] = host.pos(p);
  if (ev.air) {
    host.anim(p.id).flipAt = w.time;
    const fy = y - p.z;
    host.fx.push({ type: 'ring', x, y: fy, t: 0, life: 0.4, r: 24, col: '235,242,250' });
    host.fx.push({ type: 'ring', x, y: fy, t: 0, life: 0.28, r: 14, col: '170,230,255' });
    for (let k = 0; k < 12; k++) {
      const a = (k / 12) * Math.PI * 2;
      host.parts.push({
        x,
        y: fy,
        vx: Math.cos(a) * 70,
        vy: Math.sin(a) * 35 + 25,
        g: 0,
        t: 0,
        life: 0.35,
        c: k % 2 ? '#ffffff' : '#bfe9ff',
        streak: true,
        drag: 5,
      });
    }
  } else {
    host.fx.push({ type: 'ring', x, y, t: 0, life: 0.35, r: 14, col: '235,242,250' });
    host.dust(x, y, 10, 5, 35);
  }
  if (ev.cloud) {
    // เหยียบเมฆา: a cloud blooms under the feet to push off from.
    const fy = y - p.z + 2;
    for (let k = 0; k < 5; k++)
      host.fx.push({
        type: 'puff',
        x: x + (k - 2) * 7 + (R() - 0.5) * 3,
        y: fy + Math.abs(k - 2) * -1.5,
        t: -k * 0.02,
        life: 0.6 + R() * 0.2,
        r: 7 + (2 - Math.abs(k - 2)) * 2,
      });
    host.float(p, 'เหยียบเมฆา', '#e8f4ff', 13);
  }
  host.sfx.jump();
});

registerFxEvent('land', (host, ev, w) => {
  const e = w.get(ev.id);
  if (!e) return;
  host.anim(e.id).landAt = w.time;
  const [x, y] = host.pos(e);
  host.dust(x, y, 12, 6, 45);
  host.fx.push({ type: 'ring', x, y, t: 0, life: 0.3, r: 16, col: '200,188,164' });
});

registerFxEvent('airReset', (host, ev, w) => {
  // Springing off the foe: a ring of qi underfoot and the jumps come back.
  const e = w.get(ev.id);
  if (!e) return;
  const [x, y] = host.pos(e);
  host.fx.push({ type: 'ring', x, y: y - e.z, t: 0, life: 0.35, r: 18, col: '255,200,120' });
  host.fx.push({ type: 'puff', x, y: y - e.z + 2, t: 0, life: 0.5, r: 8 });
  host.float(e, 'กระโดดได้อีกครั้ง', '#ffd890', 12);
});

registerFxEvent('sheathe', (host, ev, w) => {
  // The renderer plays the weapon carried home or drawn out from this moment (`SHEATHE_TIME`).
  const a = host.anim(ev.id);
  a.sheatheAt = w.time;
  a.sheatheOn = ev.on;
  // A glint where the blade slides home, or flashes out.
  const e = w.get(ev.id);
  if (!e) return;
  const [x, y] = host.pos(e);
  host.fx.push({
    type: 'star',
    x: x - 6,
    y: y - 30,
    t: 0,
    life: 0.25,
    r: ev.on ? 8 : 12,
    col: '235,245,255',
  });
  if (!ev.on) host.swingArc(e, 'rising', '220,235,255', 0.8);
  host.sfx.swing();
});

registerFxEvent('mount', (host, ev, w) => {
  // The sword flies in under the feet (or leaps back to its owner's back) in a flash of qi.
  const e = w.get(ev.id);
  if (!e) return;
  const [x, y] = host.pos(e);
  host.fx.push({ type: 'ring', x, y, t: 0, life: 0.45, r: 22, col: '150,225,255' });
  host.fx.push({ type: 'ring', x, y, t: 0.1, life: 0.5, r: 12, col: '255,255,255' });
  host.burst(x, y - 4, 14, ['#bfe9ff', '#ffffff', '#7fd0ff'], 50, 20, 0.45);
  if (ev.mount) host.fx.push({ type: 'star', x, y: y - 6, t: 0, life: 0.25, r: 14, col: '200,240,255' });
  host.sfx.dash();
});
